module.exports = __webpack_public_path__ + "static/img/ram.ddd6ca43.jpg";